import * as React from "react";
import { TextList } from "../TextList";
import { TextListItem } from "../TextListItem";
import { DataInfo } from "../DataInfo";
import { strings } from "../../localization";
import { observer } from "mobx-react-lite";
import { formatAmount, formatMonthByNumber } from "../../utils/formatters";
import { colors } from "../../theme/colors";
interface IProps {
	FGTSBalance: number | string;
	birthMonth: number | string;
}

export const ColdSimulationDataCard: React.FC<IProps> = observer((props) => {
	const { FGTSBalance, birthMonth } = props;
	const {
		components: { coldSimulationDataCard },
	} = strings;

	const customStyle = {
		title: {
			fontFamily: "VivoType",
			fontSize: { base: "20px", lg: "28px" },
			lineHeight: { base: "24px", lg: "32px" },
			fontWeight: 500,
			color: colors.black[500],
		},
		name: {
			fontFamily: "VivoType",
			fontSize: { base: "14px", lg: "16px" },
			lineHeight: { base: "20px", lg: "24px" },
			fontWeight: 600,
			color: colors.black[500],
		},
		description: {
			fontFamily: "VivoType",
			fontSize: { base: "14px", lg: "16px" },
			lineHeight: { base: "20px", lg: "24px" },
			fontWeight: 500,
			color: colors.gray[600],
		},
	};

	return (
		<DataInfo title={coldSimulationDataCard.title} titleStyle={customStyle.title}>
			<TextList>
				<TextListItem
					name={coldSimulationDataCard.FGTSBalance}
					description={formatAmount(+FGTSBalance)}
					nameProps={customStyle.name}
					descripitionProps={customStyle.description}
				/>
				<TextListItem
					name={coldSimulationDataCard.birthMonth}
					description={formatMonthByNumber(+birthMonth)}
					nameProps={customStyle.name}
					descripitionProps={customStyle.description}
				/>
			</TextList>
		</DataInfo>
	);
});
